<script lang="ts">
import { Word } from "../dictionary/Word";
import Collection from "../materialize/components/Collection.svelte";
import CollectionItem from "../materialize/components/CollectionItem.svelte";

import Panel from "../materialize/components/Panel.svelte";
import Column from "../materialize/grid/Column.svelte";
import Row from "../materialize/grid/Row.svelte";
import AudioButton from "../utils/AudioButton.svelte";
import WordAudioButton from "./subcomponents/WordAudioButton.svelte";
import WordDetails from "./subcomponents/WordDetails.svelte";
import WordSearchModalPopup from "./subcomponents/WordSearchModalPopup.svelte";

let tutorial_data = [
    {
        title: "Lettera \"<strong>ö</strong>\"",
        description: `Primo suono non presente in italiano? Prima lettera per esprimerlo.
        Il suono è simile al francese "feu"`,
        word_obj: new Word({id:7887,word:"fögu"}),
    },
    {
        title: "Lettera \"<strong>ü</strong>\"",
        description: `Una "u chiusa", simile al francese "sucre". Notare la differenza tra la prima e la seconda 'u'`,
        word_obj: new Word({id:5672, word:"abatüu"}),
    },
    {
        title: "Lettera \"<strong>j</strong>\"",
        description: `La lettera "j" non va letta come in "jeans". È più simile a una i breve, come nell'esempio.`,
        word_obj: new Word({id:6115, word:"àju"}),
    },
    {
        title: "Lettera \"<strong>x</strong>\"",
        description: `La X indica il suono del francese "Journal". La "j" indicava già un altro suono, quindi si è reso necessario usare una lettera a parte`,
        word_obj: new Word({id:11756, word:"paxe"})
    },
    {
        title: "Lettere \"<strong>s-c</strong>\"",
        description: `A volte in dialetto è necessario pronunciare "sc" come due lettere separate, anziché come in "sciare" o "shhh!".
            È sufficiente aggiungere un trattino tra le due lettere per segnalarlo`,
        word_obj: new Word({id:7201, word:"s-ciòpu"})
    }    
];

</script>

<h1 class="center-align">Scrivere in dialetto</h1>
<blockquote>
    "Come posso scrivere correttamente in dialetto?"
</blockquote>
<p>Questa è forse una delle principali domande che ci vengono poste.<br>
    Sia i principianti, sia chi conosce il dialetto ma lo ha sempre solo usato in forma orale, incontrano questa difficoltà.</p>
<p>Ma non temere!</p>
<p>Abbiamo realizzato questa intuitiva guida proprio per te. Ogni esempio ha un audio da ascoltare per conoscere la corretta pronuncia, registrata da un parlante nativo.</p>

<h4>Suoni della lingua italiana</h4>
<p>I suoni della lingua italiana vengono, semplicemente, scritti come in italiano. <br>Una bella comodità!</p>
<h4>Suoni non presenti in italiano</h4>
<p>Alcuni suoni presenti in dialetto non esistono in italiano.<br>
    Per questo motivo, è necessario usare alcune lettere apposta per esprimerli</p>
<Row>
    {#each tutorial_data as single_example}
    <Column small={12} medium={6} large={4}>
        <Panel>
            <h5>{@html single_example.title}</h5>
            <p>{single_example.description}</p>
            <Collection>
                <CollectionItem>Esempio:
                    <WordDetails word={ single_example.word_obj }></WordDetails>
                </CollectionItem>
            </Collection>
        </Panel>
    </Column>
    {/each}
</Row>
